<template>
    <button @click.stop="toggleProfile" class="footer-button" :class="{active: menuOpen}">
        <svg width="20px" height="20px" viewBox="0 0 16 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Search-/-Explore" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Main---New-Nav" transform="translate(-335.000000, -747.000000)" fill="#000000" fill-rule="nonzero">
                    <g id="Group-11" transform="translate(335.000000, 747.000000)">
                        <g id="Group">
                            <path d="M7.72799984,10.204662 C9.71934746,10.2105975 11.517929,9.01562369 12.2841165,7.17756557 C13.0503039,5.33950744 12.6329971,3.22084912 11.2270065,1.81063948 C9.82101584,0.40042984 7.70361739,-0.0232231459 5.86327183,0.73745357 C4.02292627,1.49813029 2.82255994,3.29312336 2.82255994,5.28447989 C2.82658043,7.99440244 5.0181015,10.1924997 7.72799984,10.204662 Z M7.72799984,1.47197139 C9.2731528,1.46604054 10.6694081,2.39242864 11.2645027,3.81840045 C11.8595974,5.24437226 11.5360713,6.88846922 10.4450605,7.98264857 C9.3540496,9.07682792 7.71089775,9.40512036 6.2832062,8.8141635 C4.85551465,8.22320663 3.92508138,6.82964363 3.92655816,5.28447989 C3.92856979,3.18404425 5.62757886,1.48010098 7.72799984,1.47197139 Z" id="Shape"></path>
                            <path d="M11.9747198,12.3684797 L3.51071993,12.3684797 C1.57264364,12.3705081 0.00202833896,13.9411234 -3.90176772e-16,15.8791997 L-3.90176772e-16,16.2471997 C0.00202833471,18.1832435 1.57099604,19.7522113 3.50703993,19.7542396 L11.9710398,19.7542396 C13.9079244,19.7542396 15.4780797,18.1840843 15.4780797,16.2471997 L15.4780797,15.8791997 C15.4780797,13.9431532 13.9107619,12.3725385 11.9747198,12.3684797 L11.9747198,12.3684797 Z M14.3777597,16.2287997 C14.3757332,17.5551217 13.3010418,18.6298131 11.9747198,18.6318396 L3.51071993,18.6318396 C2.18296101,18.6318396 1.10603019,17.556557 1.10399998,16.2287997 L1.10399998,15.8607997 C1.10601963,14.533878 2.18012286,13.4581299 3.50703993,13.4540797 L11.9710398,13.4540797 C13.2979568,13.4581299 14.37206,14.533878 14.3740797,15.8607997 L14.3777597,16.2287997 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        <span>Me</span>
    </button>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                menuOpen: 'menu/menuOpen'
            })
        },
        methods: {
            toggleProfile() {
                this.$store.commit({
                    type: 'menu/toggleMenu'
                });
                this.$emit('click');
            },
        }
    }
</script>
